import { AxiosResponseHeaders } from 'axios';
import { constructDealerRateCountdownTimerDurationInSeconds } from '../../../utils';
import { DealerRatesResponseDTO, DealerRatesWithCalculatedTimer } from '../entities/DealerRatesResponseDTO';

const dealerRatesResponseDTOToDealerRatesAdapter = (
  data: DealerRatesResponseDTO,
  headers?: AxiosResponseHeaders,
): DealerRatesWithCalculatedTimer => {
  if (!data.body) {
    throw new Error('Error');
  }

  return Object.assign(
    { ...data.body },
    {
      calculatedDiffInSeconds: constructDealerRateCountdownTimerDurationInSeconds(
        data.body.rateTrxDate,
        data.body.rateActiveTime,
      ),
    },
  );
};

export { dealerRatesResponseDTOToDealerRatesAdapter };
